import type { DictionaryLookupResult } from '@en3/shared';
import { api } from './client';

/**
 * 词典接口（阶段 3）。
 *
 * 一个设计要点：**查词是高频请求，不能每点一个词就发一次网络往返后干等**。
 * 因此这里只提供最小的 `lookup` 封装，把"缓存 + 预取 + 取消"留给调用方
 * （阅读页用 TanStack Query 的 `queryKey: ['lookup', lemma, context]` 自动完成去重与缓存）。
 */

export interface LookupParams {
  word: string;
  /** 所在句子。给了才会算「文中义」 */
  context?: string;
  articleId?: string;
  sentenceId?: string;
  tokenIndex?: number;
  /** 阅读页点词时传 true：会累加该词的查词次数（用于水平预测的特征） */
  track?: boolean;
}

export const dictionaryApi = {
  lookup: (params: LookupParams) =>
    api.post<DictionaryLookupResult>('/api/dictionary/lookup', {
      word: params.word,
      ...(params.context ? { context: params.context } : {}),
      ...(params.articleId ? { articleId: params.articleId } : {}),
      ...(params.sentenceId ? { sentenceId: params.sentenceId } : {}),
      ...(params.tokenIndex === undefined ? {} : { tokenIndex: params.tokenIndex }),
      ...(params.track === undefined ? {} : { track: params.track }),
    }),
};
